<p *ngIf="config" class="my-3">{{ config.label }}</p>
